import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';


export const Abajo = () => {


    const history = useHistory();

    const data = history.location.state;

   // console.log('data viene: ', data);

    const sendTagLocator = () => {
          history.push("/locator");
    }


    useEffect(() => {
   
        async  function fetchInitialData() {
          if (data) {
            
          }else{
            history.push("/");
          }
        
          
        }
        fetchInitialData();
        
      }, []);





  return (
    <div className="contenedorPromociones">

        <>
            <div className="logoUnefon animate__animated animate__slideInLeft"></div>
            <div className="promo expirada">
                        
            <div className="titulo">Servicio de pago no disponible.</div>
            <p>Espera unos minutos y vuelve a entrar al enlace de la promoción o haz tu recarga en algun punto de recarga</p>

            <div className="botonera">
                    
                    <div  onClick={sendTagLocator} className="btn btnpagotienda animate__animated animate__flipInX" >Localiza puntos de recarga</div>
                 
                </div>
                <div className="legalRecarga">Recuerda que puedes realizar tu recarga en tu tienda favorita o en mi AT&T.</div>
        
        
        </div>

            
        </>  
       
    </div>
  )
}
